import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const Reporting = lazyNamed(() => import("./reporting"), "Reporting");
const OverviewTab = lazyNamed(
  () => import("./tabs/overview-tab"),
  "OverviewTab",
);
const CampaignsTab = lazyNamed(
  () => import("./tabs/campaigns-tab"),
  "CampaignsTab",
);
const DeliverabilityTab = lazyNamed(
  () => import("./tabs/deliverability-tab"),
  "DeliverabilityTab",
);

export const routes: RouteObject[] = [
  {
    path: "native-delivery/reporting",
    spacesAccess: "hidden-from-limited-view",
    element: <Reporting />,
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <Navigate to="overview" replace />,
      },
      {
        path: "overview",
        spacesAccess: "hidden-from-limited-view",
        element: <OverviewTab />,
      },
      {
        path: "campaigns",
        spacesAccess: "hidden-from-limited-view",
        element: <CampaignsTab />,
      },
      {
        path: "deliverability",
        spacesAccess: "hidden-from-limited-view",
        element: <DeliverabilityTab />,
      },
    ],
  },
];
